(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["hair-diagnostic"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-hair-quiz]').forEach((quiz) => {
    if (quiz.dataset.ready === 'true') return;
    quiz.dataset.ready = 'true';
    const intro = quiz.querySelector('[data-quiz-intro]');
    const form = quiz.querySelector('[data-quiz-form]');
    const results = quiz.querySelector('[data-quiz-results]');
    const questions = Array.from(quiz.querySelectorAll('[data-quiz-question]'));
    const progressText = quiz.querySelector('[data-quiz-progress-text]');
    const progressBar = quiz.querySelector('[data-quiz-progress-bar]');
    const previous = quiz.querySelector('[data-quiz-prev]');
    const next = quiz.querySelector('[data-quiz-next]');
    const error = quiz.querySelector('[data-quiz-error]');
    let current = 0;

    const showQuestion = (index) => {
      current = index;
      questions.forEach((question, questionIndex) => {
        question.hidden = questionIndex !== current;
      });
      previous.hidden = current === 0;
      progressText.textContent = `${current + 1} / ${questions.length}`;
      progressBar.style.width = `${((current + 1) / questions.length) * 100}%`;
      error.hidden = true;
      questions[current].querySelector('legend').focus?.();
    };

    const start = () => {
      intro.hidden = true;
      results.hidden = true;
      form.hidden = false;
      showQuestion(0);
    };

    const showResult = () => {
      const scores = { derma: 0, revital: 0, hydro: 0, formula: 0, glowwa: 0 };
      new FormData(form).forEach((value) => {
        String(value).split(',').filter(Boolean).forEach((score) => {
          const [key, points] = score.split(':');
          if (key in scores) scores[key] += Number(points || 0);
        });
      });
      const priority = ['hydro', 'revital', 'derma', 'formula', 'glowwa'];
      const winner = priority.reduce((best, key) => scores[key] > scores[best] ? key : best, priority[0]);
      form.hidden = true;
      results.hidden = false;
      quiz.querySelectorAll('[data-quiz-result]').forEach((result) => {
        result.hidden = result.dataset.quizResult !== winner;
      });
      results.scrollIntoView({ behavior: 'smooth', block: 'center' });
    };

    quiz.querySelector('[data-quiz-start]').addEventListener('click', start);
    next.addEventListener('click', () => {
      const selected = questions[current].querySelector('input:checked');
      if (!selected) {
        error.hidden = false;
        return;
      }
      if (current < questions.length - 1) showQuestion(current + 1);
      else showResult();
    });
    previous.addEventListener('click', () => {
      if (current > 0) showQuestion(current - 1);
    });
    quiz.querySelector('[data-quiz-reset]').addEventListener('click', () => {
      form.reset();
      results.hidden = true;
      intro.hidden = false;
      quiz.scrollIntoView({ behavior: 'smooth', block: 'start' });
    });
    document.querySelectorAll('a[href="#diagnostic-capillaire"]').forEach((link) => {
      link.addEventListener('click', () => {
        if (intro.hidden === false) start();
      });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
